"use client";

import { AppRouterContext } from "next/dist/shared/lib/app-router-context.shared-runtime";
import type { ReactNode } from "react";

/**
 * Keeps a product shot's links from reaching for the application.
 *
 * Bridged components link to application routes (/workspace/sessions/…,
 * /workspace/inbox …) that do not exist on the marketing site. next/link
 * prefetches a link as it scrolls into view through the router it finds in
 * AppRouterContext, and mounts it without prefetching when that context is
 * empty. The sandbox empties it for its subtree, so a shot's menu bar and
 * session list render the product's real links without the page requesting
 * a single app route. Clicks are the shot's own concern: static shots are
 * inert, and interactive ones intercept the links they turn into moments.
 */
export function ProductLinkSandbox({ children }: { children: ReactNode }) {
  return (
    <AppRouterContext.Provider value={null}>{children}</AppRouterContext.Provider>
  );
}
